'use strict';

angular.module('oddCampaignModule', []);